"use client";

import KeycloakGate from "@/components/auth/KeycloakGate";
import AppHeader from "@/layout/AppHeader";
import AppSidebar from "@/layout/AppSidebar";
import Backdrop from "@/layout/Backdrop";
import React from "react";

export default function AdminLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <KeycloakGate>
      <div className="min-h-screen lg:flex">
        {/* Sidebar and Backdrop */}
        <AppSidebar />
        <Backdrop />
        {/* Main Content Area */}
        <div
          className="flex min-w-0 flex-1 flex-col transition-all duration-300 ease-in-out"
        >
          {/* Header */}
          <AppHeader />
          {/* Page Content */}
          <div className="min-w-0 w-full max-w-(--breakpoint-2xl) flex-1 p-4 md:p-6">
            {children}
          </div>
          <footer className="mt-auto border-t border-gray-200 bg-white px-4 py-3 text-center text-sm text-gray-500 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 md:px-6">
            © 2026 owmCRM
          </footer>
        </div>
      </div>
    </KeycloakGate>
  );
}
